import { render, staticRenderFns } from "./callPhone.vue?vue&type=template&id=ed85d0ee&scoped=true"
import script from "./callPhone.vue?vue&type=script&lang=js"
export * from "./callPhone.vue?vue&type=script&lang=js"
import style0 from "./callPhone.vue?vue&type=style&index=0&id=ed85d0ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed85d0ee",
  null
  
)

export default component.exports